import React from 'react';
import { Trans } from 'react-i18next';

import { Typography, TypographyProps } from '../Typography/Typography';

type Props = TypographyProps & {
  transColoredClassname?: `text${string}`;
  href?: string;
};

const getTransComponents = (coloredClassname: `text${string}`, href: string) => {
  return {
    colored: <span className={coloredClassname} />,
    b: <span className="font-bold" />,
    br: <br />,
    strong: <strong />,
    a: <a className="font-bold underline text-primary hover:text-secondary visited: text-secondary-300" href={href} target="_blank" />
  };
};

export const RichTypography = ({ children, transColoredClassname = 'text-primary-600', href = '', ...props }: Props) => {
  return (
    <Typography {...props}>
      <Trans components={getTransComponents(transColoredClassname, href)}>{children}</Trans>
    </Typography>
  );
};
